// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02786e91","879":"0579abc1","963":"99dec44b"}[chunkId] + ".chunk.js";
};